import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.y1z_1 = serializer;
        this.z1z_1 = new (SerialDescriptorForNullable())(this.y1z_1.r1m());
      }
      r1m() {
        return this.z1z_1;
      }
      a20(encoder, value) {
        if (!(value == null)) {
          encoder.e1t();
          encoder.b1t(this.y1z_1, value);
        } else {
          encoder.e1s();
        }
      }
      s1m(encoder, value) {
        return this.a20(encoder, value);
      }
      t1m(decoder) {
        return decoder.t1q() ? decoder.h1r(this.y1z_1) : decoder.u1q();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.y1z_1, other.y1z_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.y1z_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.h1p_1 = original;
        this.i1p_1 = this.h1p_1.u1n() + '?';
        this.j1p_1 = cachedSerialNames(this.h1p_1);
      }
      u1n() {
        return this.i1p_1;
      }
      r1q() {
        return this.j1p_1;
      }
      g1p() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.h1p_1, other.h1p_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.h1p_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.h1p_1), 31);
      }
      n1p() {
        return this.h1p_1.n1p();
      }
      o1p() {
        return this.h1p_1.o1p();
      }
      p1p() {
        return this.h1p_1.p1p();
      }
      q1p() {
        return this.h1p_1.q1p();
      }
      r1p(index) {
        return this.h1p_1.r1p(index);
      }
      s1p(name) {
        return this.h1p_1.s1p(name);
      }
      t1p(index) {
        return this.h1p_1.t1p(index);
      }
      u1p(index) {
        return this.h1p_1.u1p(index);
      }
      v1p(index) {
        return this.h1p_1.v1p(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
